import { InfoCircleOutlined } from "@/icons"

import { Alert } from "@/atoms"
import cn from "classnames"
import styles from "./InformationAlert.module.scss"
import { Props } from "./InformationAlert.types"

export const InformationAlert = (props: Props) => {
  const { className, icon, palette, type = "info", message, ...rest } = props

  return (
    <Alert
      showIcon
      className={cn(className, styles.alert, styles.infoIcon, {
        [styles.neutralPalette]: palette === "neutral",
        [styles.successPalette]: palette === "success",
        [styles.infoPalette]: palette === "info",
        [styles.infoType]: type === "info"
      })}
      type={type}
      icon={icon || <InfoCircleOutlined />}
      title={message}
      {...rest}
    />
  )
}
